import { Component, ViewEncapsulation } from '@angular/core';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { locale as english } from './i18n/en';
import { locale as spanish } from './i18n/es';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from '@angular/router';
import { DataManagement } from 'app/services/dataManagement';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'environments/environment';

@Component({
    selector: 'mail-confirm',
    templateUrl: './mail-confirm.component.html',
    styleUrls: ['./mail-confirm.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class MailConfirmComponent {

    /**
     * Puede ser: 
     * 
     * - "validacion": se utiliza para validar el email asociado al token recibido.
     * - "envioEmail": se utiliza para informar al cliente de que se le ha enviado un correo.
     * - "muestraError": se muestra un mensaje de error.
     */
    tipoAccion: string;

    //Atributos del cliente
    token: string;
    email: string;

    //Atributo de carga
    loading: boolean;

    //Mensajes
    mensaje1: string;
    mensaje2: string;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     */
    constructor(
        private cookieService: CookieService,
        private _fuseConfigService: FuseConfigService,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private router: Router,
        private route: ActivatedRoute,
        private dm: DataManagement,
        private translate: TranslateService
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
        this._fuseTranslationLoaderService.loadTranslations(english, spanish);
    }

    async ngOnInit() {
        this.loading = true;
        try {
            //Intentamos rescatar el id
            this.token = this.route.snapshot.paramMap.get('token') || "";
            if (this.token) {
                //Tenemos token, por lo que se trata de una validación
                this.tipoAccion = "validacion";
                //Obtenemos el email para buscar al cliente
                this.email = this.route.snapshot.queryParamMap.get('email') || "";
                if (this.email) {
                    let resClient = await this.dm.getClientByEmail(this.email);
                    //Comprobamos que la respuesta es buena, y que el token del cliente es el mismo que el obtenido por parámetros
                    if (resClient.status == 'ok') {
                        //console.log(resClient)
                        if (resClient.message.length > 0) {
                            if (resClient.message[0].token == this.token) {
                                //Activamos el cliente confirmando su email.
                                let campos = {
                                    email: this.email, 
                                    sinConfirmarEmail: false
                                }
                                let resEdit = await this.dm.editarCliente(null, false, campos)
                                if (resEdit.status == 'ok') {
                                    //console.log(resEdit)
                                    let asunto = "[SmartBiometrik] Registro en SmartBiometrik completado";
                                    let mensaje = `<h3>Hola ` + resEdit.client.razonSocial + `</h3>
                                                  <p>Le informamos que su registro se ha realizado correctamente en SmartBiometrik</p>
                                                  <p>Sus credenciales de acceso al panel de control son:</p>
                                                  <ul>
                                                    <li>Enlace de acceso: <a href="https://dashboard.smartbiometrik.com/" />https://dashboard.smartbiometrik.com/</a></li>
                                                    <li>Correo electrónico: `+ resEdit.client.email + `</li>
                                                  </ul>
                                                  <p>En la sección de ayuda podrá ver el manual de uso y vídeos explicativos.</p>
                                                  <p>Dispone de 5 firmas gratuitas. Recuerde que debe acceder a la sección “Mi Perfil” y “Mi Suscripción” para configurar sus datos de pago y seleccionar el plan que mejor se adapte a las necesidades de su empresa.</p>
                                                  <p>Por favor no responda a este email. Si tiene cualquier duda puede contactar con nosotros en soporte@smartbiometrik.com</p>
                                                  <br />
                                                  <em>Gracias por confiar en SmartBiometrik.</em><br />
                                                  <em>Un cordial saludo.</em><br />`;
                                    let mailTo = resEdit.client.email;
                                    let cc = "";
                                    let cco = "";
                                    this.dm.sendGenericMail(asunto, mensaje, mailTo, cc, cco, true);
                                } else {
                                    throw "error_activar_cliente";
                                }
                            } else {
                                throw "error_cliente_token";
                            }
                        } else {
                            throw "error_cliente_token";
                        }
                    } else {
                        throw "error_cliente";
                    }
                } else {
                    //No disponemos del email, por lo que devolvemos error
                    throw "error_no_email";
                }
            } else {
                //No tenemos token, por lo que se trata de un envío de email
                this.tipoAccion = "envioEmail";
                if (this.cookieService.get('dashSmartBiometrikEmailConfirm') && this.cookieService.get('dashSmartBiometrikEmailConfirm') != "null") {
                    this.email = this.cookieService.get('dashSmartBiometrikEmailConfirm');
                    //Borramos la cookie
                    if (environment.production) {
                        this.cookieService.set('dashSmartBiometrikEmailConfirm', null, 0, '/', ".smartbiometrik.com", true, "Strict");
                    } else {
                        this.cookieService.set('dashSmartBiometrikEmailConfirm', null, 0, '/', "", false, "Strict");
                    }
                } else {
                    this.router.navigateByUrl("/pages/auth/login");
                }
            }
        } catch (error) {
            //console.log("error: ", error);
            this.tipoAccion = "muestraError";
            if (error == "error_no_email") {
                this.mensaje1 = this.translate.instant("MAIL_CONFIRM.ERROR.ERROR_INFO_1");
            } else if (error == "error_cliente") {
                this.mensaje1 = this.translate.instant("MAIL_CONFIRM.ERROR.ERROR_INFO_2");
            } else if (error == "error_cliente_token") {
                this.mensaje1 = this.translate.instant("MAIL_CONFIRM.ERROR.ERROR_INFO_3");
            } else if (error == "error_activar_cliente") {
                this.mensaje1 = this.translate.instant("MAIL_CONFIRM.ERROR.ERROR_INFO_4");
                this.mensaje2 = this.translate.instant("MAIL_CONFIRM.ERROR.ERROR_INFO_6");
            } else {
                this.mensaje1 = this.translate.instant("MAIL_CONFIRM.ERROR.ERROR_INFO_5");
                this.mensaje2 = this.translate.instant("MAIL_CONFIRM.ERROR.ERROR_INFO_6");
            }
            
        } finally {
            this.loading = false;
            //console.log("token: ", this.token);
            //console.log("email: ", this.email);
            //console.log("tipoAccion: ", this.tipoAccion);
        }
    }
}
